<template>
     <v-container>
        <v-dialog v-model="mainDialog" max-width="1300px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="primary"
                dark
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                small
                ><v-icon>mdi-plus</v-icon> เพิ่ม</v-btn>
            </template>
            <v-card tile>
            <v-card-title>เพิ่มข้อมูลอะไหล่</v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                    <v-col><DatePicker @dateFormatted="setDocDate"  label="วันที่ในเอกสาร"> </DatePicker></v-col>
                    <v-col><DatePicker @dateFormatted="setReceiveDate" label="วันที่รับอะไหล่"> </DatePicker></v-col>
                </v-row>
                <v-row>
                    <v-col><v-text-field 
                        autofocus
                        :rules="[rules.required, chkCode]" 
                        v-model="mainData.receiveNo" outlined placeholder=" "
                        label="เลขที่ใบรับอะไหล่"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.jobNo" @keyup="jobPartsNotFound = false" @blur="onJobNoEnter" @keyup.enter.native="onJobNoEnter" outlined placeholder=" " label="เลขที่ใบสั่งซ่อม"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.percentDiscount" value="0" maxlength="3" v-mask="'###'"  outlined placeholder=" " label="ส่วนลด"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.receiver"   outlined placeholder=" " label="ผู้รับ"></v-text-field></v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-data-table
                        :headers="header"
                        :items="mainData.details"
                        style="border:0.2px solid; border-color:#909090"
                        >
                        <template v-slot:top>
                             <v-toolbar flat color="white">
                                 <v-toolbar-title>ข้อมูลอะไหล่</v-toolbar-title>
                                 <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                                 ></v-divider>
                                 <span v-if="jobPartsNotFound" class="red--text">
                                    ** ไม่พบข้อมูลอะไหล่จากใบแจ้งซ่อม {{mainData.jobNo}}**
                                </span>
                             </v-toolbar>
                             <v-divider
                                    class="mx-4"
                                    inset
                             ></v-divider>
                             <v-form ref="formParts" v-model="validPartsData" lazy-validation>
                             <v-row class="mx-2">
                                        <v-col>
                                            <v-autocomplete
                                                autofocus
                                                v-model="selectedParts"
                                                outlined 
                                                placeholder="พิมพ์รหัส หรือ ชื่ออะไหล่"
                                                :items="partsList"
                                                return-object
                                                item-text="partsTextDisplay"
                                                item-value="partsCode"
                                                :rules="[rules.requiredObject]"
                                                label="อะไหล่">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="2"><v-text-field :rules="[rules.requiredNumber]"  v-model="detail.qty" outlined placeholder=" " label="จำนวน" maxlength="4" v-mask="'####'"></v-text-field></v-col>
                                        <v-col cols="2"><v-text-field v-model="detail.unitPrice"  outlined placeholder=" " label="ราคา" maxlength="4" ></v-text-field></v-col>
                                      <!--  <v-col cols="2"><v-text-field :rules="[rules.required]" v-model="detail.estimateNo" outlined placeholder=" " label="เลขที่ใบประเมิน"></v-text-field></v-col> -->
                                        <v-col cols="2">
                                            <v-btn class="ma-2" color="primary" @click="saveDetail">เพิ่ม</v-btn>
                                            <v-btn class="ma-2" color="primary" @click="closeDialog"> ล้าง</v-btn>
                                        </v-col>
                                    </v-row>
                             </v-form>
                        </template>
                            <template v-slot:header.discount>
                                <thead>
                                    <tr>
                                        <th colspan="2" class="indigo--text text-center">ส่วนลด</th>
                                    </tr>
                                    <tr>
                                        <th class="indigo--text text-center">%</th>
                                        <th class="indigo--text text-center">ยอด</th>
                                    </tr>
                                </thead>
                            </template>

                            <template v-slot:item.discount="{item}">
                                <tr>
                                    <th class="text-center">{{item.percentDiscount}}</th>
                                    <th class="text-center">{{item.discount}}</th>
                                </tr>
                            </template>

                             <template v-slot:item.action="{ item }">
                                <v-icon
                                    small
                                    @click="deleteDetail(item)"
                                >
                                    delete
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                 <v-row>
                    <v-col cols="6">
                        <v-data-table
                        :headers="headerSummary"
                        :items="itemSummary"
                        style="border:0.2px solid; border-color:#909090"
                        hide-default-footer
                        >
                        </v-data-table>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex align-end align-center">
                        <v-btn style="margin-right:10px;" color="primary" @click="save">บันทึก</v-btn>&nbsp;
                        <v-btn color="primary"  @click="close">ยกเลิก</v-btn>
                    </v-col>
                </v-row>
                </v-form>
                
            </v-container>
            
        </v-card>
        </v-dialog>
     </v-container>
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {insertStockParts, listDetailByJobNo, existReceiveNo} from '@/api/stock/stock-parts-api.js'
import {listDropdownParts} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'
import dialog from '@/assets/js/dialog.js'

export default {
    name: 'AddParts',
    props: ["branchCode"],
    components: {
        DatePicker
    },
    computed: {
         chkCode() {
            if (this.isDup == true) return 'เลขที่ใบรับอะไหล่ซ้ำ';
            return true;
        },
    },
    watch: {
        selectedParts(val) {
            this.detail.unitPrice = val.unitPrice;
        },
        mainDialog(val) {
            if (val) {
                this.listPartsData();
                this.resetSummary();
            }
        },
        'mainData.receiveNo': function(newVal) {
            if (newVal) {
                existReceiveNo(newVal, this.branchCode).then(response => {
                    this.isDup = response;
                }).catch(() => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        jobPartsNotFound: false,
        mainDialog: false,
        rules: {
            requiredObject: value => {
                return !!value.partsCode || 'Required.'
            },
            required: value => !!value || 'Required.',
            requiredNumber: value => value > 0 || 'กรุณากรอกตัวเลขที่มีค่ามากกว่า 0'
        },
        valid: false,
        validPartsData: false,
        header: [
            {text: 'หมายเลขอะไหล่', value: 'partsCode', class: 'indigo--text'},
            {text: 'ชื่อรายการอะไหล่', value: 'partsName', class: 'indigo--text'},
            {text: 'จำนวน', value: 'qty', class: 'indigo--text'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay', class: 'indigo--text'},
            {text: 'ยอดรวม', value: 'amountDisplay', class: 'indigo--text'},
            {text: 'ส่วนลด', value: 'discountDisplay', sortable: false, class: 'indigo--text'},
            {text: 'รวมสุทธิ', value: 'netAmountDisplay', class: 'indigo--text'},
            //{text: 'เลขที่ใบประเมิน', value: 'estimateNo', class: 'indigo--text'},
            {text: 'Actions', value: 'action', sortable: false, class: 'indigo--text'}
        ],
        mainData: {
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            jobNo: '',
            percentDiscount: 0,
            receiver: '',
            details: []
        },
        defaultMainData: {
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            jobNo: '',
            percentDiscount: 0,
            receiver: '',
            details: []
        },
        detail: {
                partsCode: '',
                partsName: '',
                unitPrice: 0,
                qty: 1,
                amount: 0,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
                estimateNo: ''
        },
        defaultDetail: {
                partsCode: '',
                partsName: '',
                unitPrice: 0,
                qty: 1,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
                estimateNo: ''
        },
        headerSummary: [
            {text: '', value: 'sumType'},
            {text: 'ยอดรวม', value: 'amountDisplay'},
            {text: 'ส่วนลด', value: 'discountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'netDisplay'}
        ],
        itemSummary: [
        ],
        partsList: [],
        selectedParts: {},
        summary: {
            sum: {
                sumType: 'รวม',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            }
        }
    }),
    methods: {
        setDocDate(val) {
            this.mainData.docDate = val;
        },
        setReceiveDate(val) {
            this.mainData.receiveDate = val;
        },
        deleteDetail(item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return;
            }
            let index = this.mainData.details.indexOf(item);
            this.mainData.details.splice(index, 1);
        },
        saveDetail() {
            if (!this.$refs.formParts.validate()) {
                return;
            }
            this.setDetailData();
            this.calculateSummary();
            this.closeDialog();
        },
        resetSummary() {
            this.summary.sum.amount = 0;
            this.summary.sum.amountDisplay = 0;
            this.summary.sum.net = 0;
            this.summary.sum.netDisplay = 0;
            this.summary.sum.discount = 0;
            this.summary.sum.discountDisplay = 0;

            this.summary.vat.amount = 0;
            this.summary.vat.net = 0;
            this.summary.vat.amountDisplay = 0;
            this.summary.vat.netDisplay = 0;
            this.summary.vat.discount = 0;
            this.summary.vat.discountDisplay = 0;

            this.summary.total.amount = 0;
            this.summary.total.net = 0;
            this.summary.total.amountDisplay = 0;
            this.summary.total.netDisplay = 0;
            this.summary.total.discount = 0;
            this.summary.total.discountDisplay = 0;
            
        },
        onJobNoEnter() {
            this.jobPartsNotFound = false;
            if (this.mainData.jobNo == undefined) {
                return;
            }
            this.$loading(true);
            this.mainData.details = [];
            this.resetSummary();
            listDetailByJobNo(this.mainData.jobNo, this.branchCode).then((rs) => {
                rs.forEach(e => {
                    this.detail = Object.assign({}, e);
                    this.mainData.details.push(this.detail);
                    this.setDisplay(this.detail);
                    this.calculateSummary();
                    this.detail = Object.assign({}, this.defaultDetail);
                });
                this.jobPartsNotFound = (this.mainData.details.length == 0);
                this.$loading(false);
            }).catch(() => {
                this.$loading(false);
            });
        },
        setDisplay(obj) {
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
            obj.amountDisplay = numeral(obj.amount).format('0,0.00');
            obj.discountDisplay = numeral(obj.discount).format('0,0.00');
            obj.netAmountDisplay = numeral(obj.netAmount).format('0,0.00');
        },
        setDisplaySummary(obj) {
            obj.amountDisplay = numeral(obj.amount).format('0,0.00');
            obj.discountDisplay = numeral(obj.discount).format('0,0.00');
            obj.netDisplay = numeral(obj.net).format('0,0.00');
        },
        setDetailData() {
            this.detail.partsCode = this.selectedParts.partsCode;
            this.detail.partsName = this.selectedParts.partsName;
            //this.detail.unitPrice = this.selectedParts.unitPrice;
            this.detail.amount = this.detail.qty * this.detail.unitPrice;
            this.detail.percentDiscount = this.mainData.percentDiscount;
            this.detail.discount = this.detail.percentDiscount == 0 ? 0 : (this.detail.amount * this.detail.percentDiscount) / 100;
            this.detail.netAmount = this.detail.amount - this.detail.discount;
            this.setDisplay(this.detail);
            this.mainData.details.push(this.detail);
        },
        calculateSummary() {
            this.summary.sum.amount += this.detail.amount;
            this.summary.sum.discount += this.detail.discount;
            this.summary.sum.net += this.detail.netAmount;
            this.setDisplaySummary(this.summary.sum);

            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.discount = (this.summary.sum.discount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;
            this.setDisplaySummary(this.summary.vat);

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.discount = this.summary.sum.discount + this.summary.vat.discount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;
            this.setDisplaySummary(this.summary.total);
        },
        closeDialog() {
            this.selectedParts = Object.assign({}, {});
            this.detail = Object.assign({}, this.defaultDetail);
        },
        close() {
            this.mainData = Object.assign({}, this.defaultMainData);
            this.mainData.details =  Object.assign([], []);
            this.detail = Object.assign({}, this.defaultDetail);
            this.selectedParts = {};
            this.resetSummary();
            //this.$emit("close");
            this.mainDialog = false;
        },
        save() {
            if (!this.$refs.form.validate() || this.mainData.details.length <= 0) {
                dialog.warn("กรุณากรอกข้อมูลให้ครบถ้วน");
                return;
            }

            this.mainData.branchCode = this.branchCode;
            this.$loading(true);
            insertStockParts(this.mainData).then( (rs) => {
                this.$loading(false);
                if (rs != undefined && rs.length > 0) {
                    dialog.warn(rs);
                    return;
                }
                this.$emit("saved");
                this.close();
            }).catch( e => {
                this.$loading(false);
                alert(e);
            });
        },
        listPartsData() {
            this.partsList = [];
            listDropdownParts().then(rs => {
                this.partsList = rs;
            })
        }
    },
    mounted() {
        this.itemSummary.push(this.summary.sum);
        this.itemSummary.push(this.summary.vat);
        this.itemSummary.push(this.summary.total);
    }
}
</script>
